import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const WhatsappIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M18.16,14.53A6.56,6.56,0,0,0,18.65,12a6.78,6.78,0,0,0-.27-1.88,8.18,8.18,0,0,1-1.87.21,8.29,8.29,0,0,1-6.8-3.52,8.48,8.48,0,0,1-4.34,4.48,5.47,5.47,0,0,0,0,.71A6.66,6.66,0,0,0,12,18.66h0a6.7,6.7,0,0,0,2.72-.58c.52,1,.76,1.49.74,1.49a11.67,11.67,0,0,1-3.46.75A8.35,8.35,0,0,1,4.05,14.5H2.83V10.33h1A8.33,8.33,0,0,1,17.88,6.12a8.19,8.19,0,0,1,2.27,4.21h1v4.12h0v.05h-.06l-3.26,3L13,17V15.42h4.43l.74-.89M9.5,11.79a1,1,0,0,1,.73.31,1,1,0,0,1,.3.73,1.07,1.07,0,0,1-.3.74,1,1,0,1,1-.73-1.78m5,0a1,1,0,1,1-1,1A1,1,0,0,1,14.49,11.79Z" />
    </SvgIcon>
  )
}
export default WhatsappIcon
